import {
    call, put, select, takeEvery,
} from 'redux-saga/effects';
import { GET_INITIAL_DATA_REQUEST } from '../constants/user_info.constants';
import { getUserInfo } from '../../requests/get_content_request';
import { getUserInfoFailure, getUserInfoSuccess, getInitialDataRequestSuccess } from '../actions/user_info.actions';
import { loginRequestSuccess } from '../actions/account_actions/login.actions';
import { message_success } from '../../../../components/Message';
import { checkLastRoute } from '../../requests/check_last_route_request';
import { checkLastRouteRequestFailure } from '../actions/check_last_route.actions';
import { routesByUrl } from '../../../../router/route.config';
import { checkPermissionRequestSuccess } from '../actions/check_permission.actions';

function* getInitialData({ token }) {
    const { App: { Login_form: { status } } } = yield select();
    if (status !== 'afterConfirm') {
        const userInfoRes = yield call(getUserInfo);

        if (userInfoRes.result) {
            const filteredByPermissionsRoutes = [];
            const payload = {
                user_info: userInfoRes.options.user_info,
                categories: userInfoRes.options.modules.sort((a, b) => a.position - b.position),
            };

            // Build routes
            // eslint-disable-next-line no-restricted-syntax
            for (const url in userInfoRes.options.allowedUrls) {
                if (routesByUrl[url]) {
                    filteredByPermissionsRoutes.push(routesByUrl[url]);
                }
            }

            yield put(getUserInfoSuccess(payload));
            yield put(checkPermissionRequestSuccess(filteredByPermissionsRoutes));
            yield put(getInitialDataRequestSuccess());

            // const last = yield call(checkLastRoute, history.location.pathname);

            // last.result
            //     ? localStorage.setItem('last_route', history.location.pathname)
            //     : yield put(checkLastRouteRequestFailure(last.error));

            // const last_route = localStorage.getItem('last_route');
            // if (localStorage.getItem('token')) {
            //     (last_route && last_route !== '/login' && last_route !== '/auth/reset-password/') ? history.push(last_route) : history.push('/Leads/Manage');
            // }
        } else {
            yield put(getUserInfoFailure(userInfoRes.error));
        }
    } else {
        yield put(loginRequestSuccess(token));
        message_success('User login successfully!');
    }
}

export default function* getInitialDataSaga() {
    yield takeEvery(GET_INITIAL_DATA_REQUEST, getInitialData);
}



// WEBPACK FOOTER //
// ./src/modules/App/redux/sagas/get_initial_data.saga.js